export default __webpack_public_path__ + "static/media/icono-emergencia-climatica.5367250f.svg";